__turbopack_context__.v({
  "category_name": "wW5ORa_category_name",
  "item": "wW5ORa_item",
  "item_info": "wW5ORa_item_info",
  "item_info_name": "wW5ORa_item_info_name",
  "item_info_role": "wW5ORa_item_info_role",
  "title": "wW5ORa_title",
});
